// frontend/src/types.ts
// Interface interne pour représenter un modèle
interface Model {
  id: string; // Identifiant unique du modèle
  name: string; // Nom affiché du modèle
}

// Récupération des modèles depuis les variables d'environnement via import.meta.env
const rawModels = import.meta.env.VITE_MODELS;

// Validation et parsing des modèles
const models: Model[] = rawModels
  ? JSON.parse(rawModels) : // Parse la chaîne JSON en tableau d'objets Model
  // : [
  //     { id: 'qwen2.5-coder-32b-instruct', name: 'Qwen 2.5 | Développeur' },
  //     { id: 'mathstral-7b-v0.1', name: 'Mixtral | Mathématicien' },
  //     { id: 'claude-3-7-sonnet-20250219', name: 'Claude 3.7 | Assistant IA' },
  //     { id: 'oh-dcft-v3.1-claude-3-5-sonnet-20241022', name: 'Claude 3.5 | Développeur' },
  //     { id: 'mixtral-8x7b-instruct-v0.1', name: 'Mixtral | Conversationnel' },
  //   ];
  [
    { id: "qwen2.5-coder-32b-instruct", name: "Qwen 2.5 | Développeur" },
    { id: "oh-dcft-v3.1-claude-3-5-sonnet-20241022@q8_0", name: "Claude 3.5 | Développeur" },
    { id: "mathstral-7b-v0.1", name: "Mixtral | Scientifique" },
    { id: "lucy-in-the-sky/mixtral-8x7b-instruct-v0.1", name: "Mixtral | Conversationnel" },
    { id: "claude-3-7-sonnet-20250219", name: "Claude 3.7 | API Claude PAYANTE" },
    { id: "gemma-3-27b-it", name: "Google | API Google" }
  ]

// Type pour les IDs des modèles
export type ModelId = string;

// Interface pour les messages dans une conversation
export interface Message {
  role: 'user' | 'assistant' | 'system';
  content: string;
  timestamp: string | Date;
}

// Interface étendue pour un message avec des métadonnées et un statut
export interface ExtendedMessage {
  sender: 'user' | 'ia' | 'system';
  content: string;
  type: 'text' | 'image' | 'video';
  modelName?: ModelId;
  messageId?: string;
  final?: boolean;
  timestamp?: string;
  status?: MessageStatus;
  conversationId?: string;
}

// Type pour les statuts possibles des messages
export type MessageStatus = 'pending' | 'sent' | 'delivered' | 'read' | 'error';

// Interface pour un chat complet
export interface Chat {
  userId: string;
  message: string;
  response: string;
  modelName: ModelId;
  timestamp: Date | string | number;
  _id?: string;
  __v?: number;
}

// Interface pour une conversation complète
export interface Conversation {
  _id: string;
  userId: string;
  modelName: ModelId;
  messages: Message[];
  title?: string;
  createdAt: string;
  updatedAt: string;
}

// Pour l'affichage des aperçus de conversations dans la liste
export interface ConversationPreview {
  _id: string;
  title?: string;
  modelName: ModelId;
  createdAt: string;
  updatedAt: string;
}

// Pour la pagination des conversations
export interface PaginatedConversations {
  conversations: ConversationPreview[];
  pagination: {
    total: number;
    page: number;
    pages: number;
  };
}

// Interface pour gérer les erreurs
export interface ChatError {
  error: string;
  message?: string;
  timestamp?: Date | number | string;
}

// Exportation des modèles disponibles
export const availableModels: readonly Model[] = models;